import React from "react"
import PropTypes from "prop-types"
import { Route, Redirect } from "react-router-dom"
import ApiRest from "../../ayudas/apiRest";

const Authmiddleware = ({
    component: Component,
    layout: Layout,
    isAuthProtected,
    ...rest
}) => (
    <Route
        {...rest}
        render={props => {

            let apiRest = new ApiRest(props);

            if (isAuthProtected && !apiRest.getLS("authUser")) {
                return (
                    <Redirect
                        to={{ pathname: "/login", state: { from: props.location } }}
                    />
                )
            }

            return (
                <Layout>
                    <Component {...props} />
                </Layout>
            )
        }}
    />
)

Authmiddleware.propTypes = {
    isAuthProtected: PropTypes.bool,
    component: PropTypes.any,
    location: PropTypes.object,
    layout: PropTypes.any,
}

export default Authmiddleware
